import {
    Mic, PartyPopper, Beer, Monitor, Landmark, GraduationCap,
    Trophy, Briefcase, UtensilsCrossed, ShoppingBag, Sparkles,
    Users, Presentation, Target, Palette, FlaskConical, BookOpen,
    Hammer, Dumbbell, Brain, Cpu, Baby, Megaphone, Map, Music,
    Drum, Radio, TrendingUp, PenLine, Award, Rainbow, Wrench,
    UserCheck, Rocket, Tag,
    // Establishment tags
    Music2, Utensils, Coffee, ChefHat, Flame, Cake, Sandwich,
    Truck, IceCream, Wine, Croissant, Pizza, Fish, Scissors,
    Building2, Lightbulb, Hotel, BedDouble, Calendar,
} from 'lucide-react';

const categoryIconMap = {
    // Event categories
    mic:               Mic,
    partyPopper:       PartyPopper,
    beer:              Beer,
    monitor:           Monitor,
    landmark:          Landmark,
    graduationCap:     GraduationCap,
    trophy:            Trophy,
    briefcase:         Briefcase,
    utensilsCrossed:   UtensilsCrossed,
    shoppingBag:       ShoppingBag,
    sparkles:          Sparkles,
    users:             Users,
    presentation:      Presentation,
    target:            Target,
    palette:           Palette,
    flaskConical:      FlaskConical,
    bookOpen:          BookOpen,
    hammer:            Hammer,
    dumbbell:          Dumbbell,
    brain:             Brain,
    cpu:               Cpu,
    baby:              Baby,
    megaphone:         Megaphone,
    map:               Map,
    music:             Music,
    drum:              Drum,
    radio:             Radio,
    trendingUp:        TrendingUp,
    penLine:           PenLine,
    award:             Award,
    rainbow:           Rainbow,
    wrench:            Wrench,
    userCheck:         UserCheck,
    rocket:            Rocket,
    // Establishment tags
    music2:            Music2,
    utensils:          Utensils,
    coffee:            Coffee,
    chefHat:           ChefHat,
    flame:             Flame,
    cake:              Cake,
    sandwich:          Sandwich,
    truck:             Truck,
    iceCream:          IceCream,
    wine:              Wine,
    croissant:         Croissant,
    pizza:             Pizza,
    fish:              Fish,
    scissors:          Scissors,
    building2:         Building2,
    lightbulb:         Lightbulb,
    hotel:             Hotel,
    bedDouble:         BedDouble,
    calendar:          Calendar,
};

export function getCategoryIcon(iconKey) {
    return categoryIconMap[iconKey] ?? Tag;
}
